import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HABIT_CREATE } from "../../routes/routes";
import { toast } from "react-toastify";
import { HABIT_CREATED } from "../../constant/constant";
import { ValidationMessage } from "../../components/Utils";

const FREQUENCY_OPTIONS = [
  { value: 1, label: "Daily" },
  { value: 2, label: "Weekly" },
  { value: 3, label: "Monthly" },
];

const WEEK_DAYS = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 7, label: "Sunday" },
];

const MONTH_DAYS = Array.from({ length: 31 }, (_, index) => index + 1);

const CreateHabit = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", frequency: "", schedule_day: "" });
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [errors, setErrors] = useState({});

  const submit = () => {
    setBtnDisabled(true);
    const frequency = Number(form.frequency);
    const payload = { name: form.name, frequency };
    if (frequency === 2 || frequency === 3) payload.schedule_day = Number(form.schedule_day);
    axios
      .post(HABIT_CREATE, payload)
      .then((res) => {
        if (res.status === 201 && res.data.success) {
          toast.success(HABIT_CREATED);
          navigate("/habits");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setBtnDisabled(false);
      });
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Habits</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/habits"}>
                    <span>Habits List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Create Habit</span></li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/habits"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body app-form-fields">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="name">
                          Habit Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          value={form.name}
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="frequency">
                          Frequency<span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          id="frequency"
                          value={form.frequency}
                          onChange={(e) =>
                            setForm({ ...form, frequency: e.target.value, schedule_day: "" })
                          }
                        >
                          <option value="">Select frequency</option>
                          {FREQUENCY_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        <ValidationMessage error={errors} name="frequency" />
                      </div>
                    </div>
                    {Number(form.frequency) === 2 && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="schedule_day">
                            Week day<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            id="schedule_day"
                            value={form.schedule_day}
                            onChange={(e) => setForm({ ...form, schedule_day: e.target.value })}
                          >
                            <option value="">Select day</option>
                            {WEEK_DAYS.map((option) => (
                              <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                          </select>
                          <ValidationMessage error={errors} name="schedule_day" />
                        </div>
                      </div>
                    )}
                    {Number(form.frequency) === 3 && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="schedule_day">
                            Day of month<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            id="schedule_day"
                            value={form.schedule_day}
                            onChange={(e) => setForm({ ...form, schedule_day: e.target.value })}
                          >
                            <option value="">Select day</option>
                            {MONTH_DAYS.map((day) => (
                              <option key={day} value={day}>Day {day}</option>
                            ))}
                          </select>
                          <ValidationMessage error={errors} name="schedule_day" />
                        </div>
                      </div>
                    )}
                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/habits"}>
                        <button type="button" className="btn btn-primary iclose_btn">
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateHabit;
